import { Card, Form } from "antd";
import React, { useEffect, useState } from "react";
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import { useNavigate } from "react-router-dom";
import PageHeader from "../pageHeader/pageheader";

function IndexMonthlyplanner() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50000); // Define the page size
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  // Fetching data for clients
  // const fetchHrClient = async (page: number, take: number) => {
  //   try {
  //     setIsLoading(true);
  //     const obj = {
  //       query: form.getFieldValue("query"),
  //       page,
  //       take,
  //     };
  //     const url = API.PAGENATION_CLIENT;
  //     const response: any = await POST(url, obj);
  //     setData(response?.data);
  //     setMeta(response?.meta);
  //   } catch (error) {
  //     console.log("Error fetching clients:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchHrClient(page, pageSize);
  // }, [page, pageSize]);



  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setData(data);
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchClient();
  }, []);
  return (
    <div>
      <PageHeader />
      <h1>Clients Details</h1>
      <div className="grid-container">
        {data?.length > 0 ? (
          data.map((client: any, index: number) => (
            <Card
              className="inner-card"
              key={index}
              onClick={() =>
                navigate(`/Admin/Monthlyplanner/planner/${client.id}`)
              }
            >
              <h6>{client.companyName}</h6>
            </Card>
          ))
        ) : (
          <p style={{ textAlign: "center", margin: "20px auto" }}>
            No clients available
          </p>
        )}
      </div>
    </div>
  );
}

export default IndexMonthlyplanner;
